import UltMeta, { Meta } from "./UltMeta/index";

class YesOrNo extends UltMeta {
    YES = new Meta(1, "是", "color-info");
    NO = new Meta(0, "否", "color-black");
}
export const YES_OR_NO = new YesOrNo();

class WebSocketReadyState extends UltMeta {
    CONNECTING = new Meta(0, "正在链接中");
    OPEN = new Meta(1, "已经链接并且可以通讯");
    CLOSING = new Meta(2, "连接正在关闭");
    CLOSED = new Meta(3, "连接已关闭或者没有链接成功");
}
export const WEBSOCKET_READY_STATE = new WebSocketReadyState();
